import { render, staticRenderFns } from "./CmgTopLevelMenu.vue?vue&type=template&id=023003bc&lang=pug"
import script from "./cmg-top-level-menu.ts?vue&type=script&lang=ts&external"
export * from "./cmg-top-level-menu.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgTopLevelMenu.vue?vue&type=style&index=0&id=023003bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports